import MuiIconButton from '@mui/material/IconButton';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import { Tooltip } from '../tooltip/tooltip';

interface CustomIconButtonProps extends MuiIconButtonProps {
  label?: string;
}

export const IconButton = (props: CustomIconButtonProps) => {
  if (props.label) {
    return (
      <Tooltip title={props.label} placement="top">
        <MuiIconButton
          sx={{
            height: props.size === 'small' ? '24px' : '40px',
            width: props.size === 'small' ? '24px' : '40px',
            ...props.sx,
          }}
          {...props}
        />
      </Tooltip>
    );
  }

  return (
    <MuiIconButton
      sx={{
        height: props.size === 'small' ? '24px' : '40px',
        width: props.size === 'small' ? '24px' : '40px',
        ...props.sx,
      }}
      {...props}
    />
  );
};
